<header class="header footer" #header>
  <!-- Fake button used for old IAB code in the app, will freeze without currently -->
  <div class="button" style="position: absolute"></div>
  @if (!enableLogout) {
    <div class="logout" routerLink="microphone-kits">
      <i class="fa fa-angle-left"></i>
    </div>
  } @else {
    <div class="logout" (click)="logout()">
      @if (inAppBrowser) {
          <i class="fa fa-angle-left"></i>
      } @else {
        <button mat-button (click)="logout()">{{ 'header.logout' | transloco }}</button>
      }
    </div>
  }

  <div class="logo" (click)="clickLogo()">
    <app-branding-logos></app-branding-logos>
  </div>

  <div class="options" [style.visibility]="!noButtons ? 'visible' : 'hidden'">
    @if (showReadAlongButton()) {
      @let unsupported = ttsAudio.unsupported();
      @let enabled = ttsAudio.enabled();
      @let readAlongLabel = unsupported ? ('header.read_along_unsupported' | transloco) : (enabled ? ('header.read_along_off' | transloco) : ('header.read_along_on' | transloco));
      <!-- aria-disabled (not [disabled]) keeps the unsupported tooltip working
           and the control discoverable in the tab order; the click guard
           covers pointer and Enter/Space alike. -->
      <button
        type="button"
        class="read-along"
        [class.disabled]="unsupported"
        [attr.aria-disabled]="unsupported"
        [attr.aria-pressed]="enabled"
        [attr.aria-label]="readAlongLabel"
        [matTooltip]="readAlongLabel"
        (click)="unsupported ? null : toggleReadAlong()">
        <i class="fa fa-fw" aria-hidden="true" [class.fa-volume-up]="enabled" [class.fa-volume-off]="!enabled"></i>
      </button>
    }
    <div class="language" (click)="openLanguageSettings()">
      <i class="fa fa-globe"></i>
    </div>
    <div class="menu" mat-button [matMenuTriggerFor]="menu">
      <i class="fa fa-bars"></i>
    </div>
    <!--
    TODO: Improve accessibility
    https://material.angular.io/components/menu/overview#accessibility
    -->
    <mat-menu #menu="matMenu" class="menu">
      @if (showDownloadButton) {
        <button mat-menu-item (click)="downloadTranscript()" [attr.aria-label]="'header.save_pc' | transloco">
          <mat-icon>save</mat-icon>
          <span>{{ 'header.save_pc' | transloco }}</span>
        </button>
      }
      <button
        mat-menu-item
        (click)="openLanguageSettings()"
        [attr.aria-label]="'header.languages' | transloco">
        <mat-icon>language</mat-icon>
        <span>{{ 'header.languages' | transloco }}</span>
      </button>
      <!-- NOTE: Not in use.
      <button mat-menu-item (click)="openMenuPersonalize()" [attr.aria-label]="'header.personalize' | transloco">
        <img src="assets/svg/personalise.svg" alt="personalize icon" />
        {{ 'header.personalize' | transloco }}
      </button> -->
      @if (showMicrophoneSettingsButton) {
        <button mat-menu-item (click)="openMenuMicrophoneSettings()" [attr.aria-label]="'header.microphone_settings' | transloco">
          <mat-icon>mic</mat-icon>
          <span>{{ 'header.microphone_settings' | transloco }}</span>
        </button>
      }
      <button
        mat-menu-item
        (click)="openMenuDisplaySettings()"
        [attr.aria-label]="'header.display' | transloco">
        <mat-icon>dvr</mat-icon>
        <span>{{ 'header.display' | transloco }}</span>
      </button>
      @if (showShareButton) {
        <button mat-menu-item (click)="openDialogShare()" [attr.aria-label]="'header.share' | transloco">
          <mat-icon>share</mat-icon>
          <span>{{ 'header.share' | transloco }}</span>
        </button>
      }
    </mat-menu>
  </div>
</header>
